import { apiClient } from '@v2/lib';
import type { Pims } from '@v2/types';

export const pimsService = {
  getPims: async (): Promise<Pims[]> => {
    const response = await apiClient().get<Pims[]>('pims');
    return Array.isArray(response.data) ? response.data : [];
  },
};
